import styled from 'styled-components';

export const OrderGroup = styled.div`
  background: #f4f3ef;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const OrderCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 15px 15px 10px 15px;
  margin-bottom: 15px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
  position: relative;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`;

export const CheckboxContainer = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  z-index: 10;

  input[type="checkbox"] {
    width: 20px;
    height: 20px;
    cursor: pointer;
    
    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
`;

export const OrderHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 15px;
  padding-bottom: 10px;
  padding-left: 30px;
  border-bottom: 2px solid #f4f3ef;

  h6 {
    margin: 0;
    color: #333;
    font-weight: 600;
    font-size: 16px;
  }

  small {
    color: #666;
    font-size: 12px;
  }
`;

export const OrderInfo = styled.div`
  margin-bottom: 10px;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
`;

export const InfoLabel = styled.span`
  font-size: 13px;
  color: #666;
  font-weight: 500;
`;

export const InfoValue = styled.span`
  font-size: 13px;
  color: #333;
  text-align: right;
  max-width: 60%;
  word-break: break-word;
`;

export const CancelButton = styled.button`
  width: 100%;
  padding: 10px;
  background: ${props => props.disabled ? '#ccc' : '#ef8157'};
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: background 0.2s;

  &:hover {
    background: ${props => props.disabled ? '#ccc' : '#d96f47'};
  }

  &:active {
    transform: ${props => props.disabled ? 'none' : 'scale(0.98)'};
  }
`;

export const FloatingCounter = styled.div`
  position: fixed;
  bottom: 30px;
  right: 30px;
  background: linear-gradient(135deg, #51cbce 0%, #3ba7aa 100%);
  color: white;
  padding: 20px 25px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(81, 203, 206, 0.4);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  min-width: 200px;
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      transform: translateY(100px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const CounterNumber = styled.div`
  font-size: 36px;
  font-weight: bold;
  line-height: 1;
`;

export const CounterLabel = styled.div`
  font-size: 14px;
  opacity: 0.9;
  text-align: center;
`;

export const CounterButton = styled.button`
  width: 100%;
  padding: 10px 20px;
  background: white;
  color: #51cbce;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 5px;

  &:hover {
    background: #f0f0f0;
    transform: scale(1.02);
  }

  &:active {
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
